import React from "react";
import DashboardLayout from "../components/DashboardLayout";

function Requests() {
  return (
    <DashboardLayout headerTitle="Requests">
      <div className="mt-[20px] text-center">Page Contents</div>
    </DashboardLayout>
  );
}

export default Requests;
